import React from 'react'
import ExpandableContainerUI from '@interflora/ui-components/build/components/ExpandableContainer/ExpandableContainer'
import { renderComponents } from 'utils/components'
import { useLoaded } from '@interflora/ui-components'

type Meta = {
  name?: string
  schema: string
  deliveryId: string
}

type Component = {
  uiType: string
  meta: Meta
  data: any
}
type ExpandableItem = {
  title: string
  components: Component[]
}

type Props = {
  title: string
  expandableItemsList: ExpandableItem[]
}
const ExpandableContainer = (props: Props) => {
  useLoaded(props)
  return <ExpandableContainerUI {...props} renderComponents={renderComponents} />
}

export default ExpandableContainer
